export class AppButton {
	private static readonly ID = "benefit-detailview_app_btn";

	init(callback: () => void, targetElement: HTMLElement) {
		const button = targetElement.querySelector(`#${AppButton.ID}`);
		button?.addEventListener("click", callback);
	}

	getButtonHtml() {
		return `<div class="benefit-detailview_partnerbenefit-subline-app-only-button">
        <button id="${AppButton.ID}" class="pl_button50--secondary benefit-detailview_app_btn"
            aria-label="Zur OTTO App Wechseln">
            <span>
                Zur App
            </span>
        </button>
    </div>`;
	}
}
